export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
import { getUserId, getOrgId, getToken, getSignature } from './auth';
export function getSSEClient(restPath, signature) {
    const baseURL = `${API_URL}/api/${restPath}`;
    async function buildHeaders() {
        const token = await getToken();
        return {
            "Content-Type": "text/event-stream",
            "Cache-Control": "no-cache",
            "X-User-Id": getUserId(),
            "X-Organization-Id": getOrgId(),
            "X-Signature": signature || getSignature(),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };
    }
    async function createEventSource(fullURL) {
        const headers = await buildHeaders();
        // Convert headers object → query params, because EventSource does not support custom headers
        // This is the standard workaround for authenticated SSE.
        const url = new URL(fullURL);
        Object.entries(headers).forEach(([key, value]) => {
            url.searchParams.append(key.toLowerCase(), String(value));
        });
        return new EventSource(url.toString());
    }
    return {
        subscribe(path, { onMessage, onError, onOpen }) {
            let es = null;
            let closed = false;
            const fullURL = `${baseURL}${path.startsWith("/") ? path : `/${path}`}`;
            const connect = async () => {
                if (closed)
                    return;
                try {
                    es = await createEventSource(fullURL);
                    es.onopen = () => {
                        onOpen?.();
                    };
                    es.onmessage = (event) => {
                        try {
                            const parsed = JSON.parse(event.data);
                            onMessage(parsed);
                        }
                        catch (err) {
                            console.warn("Invalid SSE JSON:", event.data);
                        }
                    };
                    es.onerror = async (err) => {
                        // Detect token-related errors (often surfaced as EventSource "error" + closed event)
                        if (err?.status === 401 || err?.message?.includes("401")) {
                            try {
                                // Refresh token
                                await getToken(); // ensures new token exists
                                // Reconnect
                                reconnect();
                                return;
                            }
                            catch (e) {
                                onError?.(e);
                            }
                        }
                        // Generic network error → auto-reconnect
                        onError?.(err);
                        reconnect();
                    };
                }
                catch (ex) {
                    onError?.(ex);
                    reconnect();
                }
            };
            const reconnect = () => {
                if (closed)
                    return;
                if (es) {
                    es.close();
                    es = null;
                }
                setTimeout(connect, 1200); // reconnect delay
            };
            connect();
            // Return unsubscribe function
            return () => {
                closed = true;
                if (es)
                    es.close();
            };
        },
    };
}
